import styled from 'styled-components';

export const HeaderStyles = styled.header`
  position: relative;
  text-align: center;

  h3 {
    margin-bottom: 12px;
  }

  p {
    margin-top: 0;
  }
`;
